// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colorNotbuy[data-v-50395d9a] {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
